var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutuscircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 97,
    width: 97,
    height: 97,
    rx: 48.5,
    transform: "rotate(180 97 97)",
    fill: "#E9EFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutuscircle);
export default __webpack_public_path__ + "static/media/aboutuscircle.7e73ceb229eb32b32aef2d7115515399.svg";
export { ForwardRef as ReactComponent };